export default __webpack_public_path__ + "static/media/landing_page2.fbeddf28.svg";